import React from 'react';
import style from './style.scss';

const LaddaButton = ({ children, loading, onSubmit, disabled}) => (
	<button className={`laddaButton ${loading ? 'dataLoading' : ''}`} onClick={onSubmit} disabled={disabled}>
		<span className="label">{children}</span>
		<span className="spinner"></span>
	</button>
);

export default LaddaButton;



// WEBPACK FOOTER //
// ./src/components/ladda-button/index.js